import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Fieldset, Legend, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { Preview, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import UpdateBloc from '../Update/Blocs/UpdateBloc'
class DetailView extends Component {
    source
    indexBloc = new IndexBloc()
    updateBloc = new UpdateBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: {},
            dataForm: {},
            statusApproval: 0
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                official_travel_uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.updateBloc.fetchApproval(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    render() {
        const { detail } = this.state
        const status = ['Disetujui', 'Ditolak']
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to='/izinpegawai/dinas.html'>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Perjalanan Dinas</CardTitle>
                                    <CardSubtitle className="mb-3">
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Nomor <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <Input
                                                    type="text" 
                                                    placeholder="Nomor Perjalanan Dinas"
                                                    errorMessage="Masukkan Nomor Perjalanan Dinas"
                                                    className="form-control"
                                                    name="official_travel_number"
                                                    value={detail?.official_travel_number}
                                                    readOnly="true" />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai 
                                            </Label>
                                            <Col md="2">
                                                <Input
                                                    name="official_travel_date"
                                                    placeholder="Tanggal Perjalanan Dinas"
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Perjalanan Dinas"
                                                    className="form-control"
                                                    readOnly={true}
                                                    value={detail?.official_travel_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai Dinas 
                                            </Label>
                                            <Col md="2">
                                                <Input
                                                    name="official_travel_end_date"
                                                    placeholder="Tanggal Selesai Perjalanan Dinas"
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Selesai Perjalanan Dinas"
                                                    className="form-control"
                                                    readOnly={true}
                                                    value={detail?.official_travel_end_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tempat Dinas 
                                            </Label>
                                            <Col md="3">
                                                <Input
                                                    name="official_travel_oversea"
                                                    type="text"
                                                    readOnly={true}
                                                    value={detail?.official_travel_oversea == 1 ? 'Dalam Negeri' : 'Luar Negeri'}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        {detail?.official_travel_oversea == 1 &&
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    </Label>
                                                    <Col md="3">
                                                        <Input
                                                            name="official_travel_domicile"
                                                            type="text"
                                                            readOnly={true}
                                                            value={detail?.official_travel_domicile == 1 ? 'Dalam Kota' : 'Luar Kota'}
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>
                                                </Row>

                                                {detail?.official_travel_domicile == 2 &&
                                                    <Fragment>
                                                        <Row className="mb-3">
                                                            <Label
                                                                className="col-md-2 col-form-label"
                                                            >
                                                            Provinsi 
                                                            </Label>
                                                            <Col md="3">
                                                                <Input
                                                                    name="official_travel_province_uuid"
                                                                    type="text"
                                                                    readOnly={true}
                                                                    value={detail?.official_travel_province}
                                                                    validate={{ required: { value: true } }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Label
                                                                className="col-md-2 col-form-label"
                                                            >
                                                                Kota 
                                                            </Label>
                                                            <Col md="3">
                                                                <Input
                                                                    name="official_travel_city_uuid"
                                                                    type="text"
                                                                    readOnly={true}
                                                                    value={detail?.official_travel_city}
                                                                    validate={{ required: { value: true } }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Fragment>
                                                }

                                            </Fragment>
                                        }



                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tujuan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="5">
                                                <Input
                                                    name="official_travel_destination"
                                                    placeholder="Tujuan Perjalanan Dinas"
                                                    type="textarea"
                                                    rows="5"
                                                    errorMessage="Masukkan Tujuan Perjalanan Dinas"
                                                    className="form-control"
                                                    value={detail?.official_travel_destination}
                                                    readOnly="true"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Keterangan 
                                            </Label>
                                            <Col md="5">
                                                <Input
                                                    name="official_travel_description"
                                                    placeholder="Keterangan Perjalanan Dinas"
                                                    type="textarea"
                                                    rows="5"
                                                    className="form-control"
                                                    value={detail?.official_travel_description}
                                                    readOnly="true"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">
                                                Surat Tugas
                                            </Label>
                                            <Col md="5">
                                                <Preview value={detail?.document} />
                                            </Col>
                                        </Row>

                                            <Fragment>
                                                {detail?.participant?.map((val, i) => {
                                                    let name = val.employee?.employee_name
                                                    let front_title = val.employee?.employee_front_title ? val.employee?.employee_front_title + '. ' : ''
                                                    let end_title = val.employee?.employee_end_title ? ' ' + val.employee?.employee_end_title : ''
                                                    name = front_title + name + end_title
                                                    return (
                                                        <Row className="mb-4">
                                                            <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label">Partisipan  <span className="text-danger">*</span></Label>
                                                            <Col sm={4}>
                                                                <AvField
                                                                    name="official_travel_participant_employee_uuid[0]"
                                                                    placeholder="Tanggal Mulai"
                                                                    type="text"
                                                                    errorMessage="Masukkan Tanggal Mulai"
                                                                    className="form-control"
                                                                    value={name}
                                                                    readOnly={true}
                                                                />
                                                            </Col>
                                                        </Row>                                                    )
                                                })}
                                            </Fragment>


                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Status Approval <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <Select
                                                    name="official_travel_approval_status"
                                                    type="text"
                                                    options={[
                                                        {value: 1, label: 'Disetujui'},
                                                        {value: 2, label: 'Ditolak'}
                                                    ]}
                                                    onChange={opt => this.setState({ statusApproval: opt.value })}
                                                    className="form-control"
                                                    defaultValue={this.state.statusApproval}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Catatan
                                            </Label>
                                            <Col md="4">
                                                <AvField
                                                    name="official_travel_note"
                                                    placeholder="Berikan Catatan Untuk Perjalanan Dinas"
                                                    type="textarea"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>
                                    
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Button color="danger" type="button" onClick={() => this.props.history.goBack()}><i className="uil-arrow-left"></i> Kembali</Button>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Fragment>
                        <Redirect to={`/izinpegawai/dinas.html`} />
                    </Fragment>
                : null }

            </Fragment>
        )
    }

}

export default withRouter(DetailView)